/**
 * Text mode for text on
 * - help for attributes and values
 * - info attributes
 */
export var TextMode;
(function (TextMode) {
    TextMode["Markdown"] = "markdown";
    TextMode["PlainText"] = "plaintext";
})(TextMode || (TextMode = {}));
export const TEXT_MODES = [
    TextMode.Markdown,
    TextMode.PlainText,
];
//# sourceMappingURL=TextMode.js.map